import { QueryClient } from '@tanstack/react-query';

/**
 * QueryClient compartilhado da aplicação.
 * staleTime alto evita refetch agressivo em telas mobile com rede instável;
 * retry baixo dá comportamento previsível para mutations e queries.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
